<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('auth.confirm') }}</h4>
                  <p>{{ $t('auth.confirm') }}</p>
                </div>

                <div class="clearfix">
                  <vs-input
                    v-validate="'required|regex:^[0-9]{4}$'"
                    data-vv-validate-on="blur"
                    name="confirmationCode"
                    :label-placeholder="$t('auth.confirm_code')"
                    v-model="confirmationCode"
                    @keyup="confirmationCode = translateNumbers(confirmationCode)"
                    :data-vv-as="$t('auth.confirm_code')"
                    class="w-full"
                  />
                  <span class="text-danger text-sm">{{ errors.first('confirmationCode') }}</span>

                  <div class="vx-row mb-2">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input
                        name="firstName"
                        data-vv-validate-on="blur"
                        :data-vv-as="$t('users.first_name')"
                        v-validate="'required|letters'"
                        :date-vv-as="$t('users.first_name')"
                        :label-placeholder="$t('users.first_name')"
                        v-model="firstName"
                        class="w-full mt-6"
                      />
                      <span class="text-danger text-sm">{{ errors.first('firstName') }}</span>
                    </div>

                    <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input
                        name="lastName"
                        v-validate="'required|letters'"
                        :data-vv-as="$t('users.last_name')"
                        data-vv-validate-on="blur"
                        :label-placeholder="$t('users.last_name')"
                        v-model="lastName"
                        class="w-full mt-6"
                      />
                      <span class="text-danger text-sm">{{ errors.first('lastName') }}</span>
                    </div>
                  </div>

                  <div class="vx-row">
                    <date-picker
                      type="date"
                      v-model="birthday"
                      element="birthday"
                      view="year"
                      :max="$moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')"
                      :min="
                        $moment()
                          .subtract(200, 'years')
                          .format('YYYY-MM-DDTHH:mm:ss.SSSZ')
                      "
                    />
                    <vs-input
                      name="birthday"
                      id="birthday"
                      :value="
                        birthday
                          ? $moment(birthday)
                              .locale($vs.rtl ? 'fa' : 'en')
                              .format('DD MMMM YYYY')
                          : ''
                      "
                      :placeholder="$t('users.birthday')"
                      v-validate="'required'"
                      :data-vv-as="$t('users.birthday')"
                      class="vx-col w-full mb-2"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('birthday')">{{
                      errors.first('birthday')
                    }}</span>
                  </div>

                  <vs-alert :active="countDown !== 0" icon="warning" color="warning" class="my-5">
                    <span>{{ countDown }}&ensp;{{ $t('messages.resend_code') }}</span>
                  </vs-alert>

                  <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-6">
                    <vs-button
                      :disabled="countDown !== 0"
                      @click="resetCountDown"
                      type="border"
                      class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                      >{{ $t('button.resend_code') }}</vs-button
                    >
                    <vs-button
                      id="button-with-loading"
                      :disabled="!validateForm || disabled_btn"
                      @click="confirmUser"
                      class="vs-con-loading__container w-full sm:w-auto"
                    >
                      {{ $t('button.log_in') }}
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { TranslateNumbers } from '@/utils'

export default {
  data() {
    return {
      backgroundLoading: 'primary',
      birthday: null,
      colorLoading: '#fff',
      confirmationCode: '',
      countDown: 60 * 2,
      disabled_btn: false,
      firstName: '',
      lastName: ''
    }
  },
  created() {
    this.countDownTimer()
  },
  computed: {
    username() {
      return this.$route.params.phone
    },
    password() {
      return sessionStorage.getItem('password')
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.confirmationCode !== '' &&
        this.lastName !== '' &&
        this.firstName !== '' &&
        this.birthday
      )
    },
    referralAffiliate() {
      return JSON.parse(sessionStorage.getItem('referralAffiliate'))
    },
    giftCode() {
      return sessionStorage.getItem('giftCode')
    }
  },
  methods: {
    resendConfirmationCode() {
      const payload = {
        username: this.username
      }

      this.$store
        .dispatch('auth/forgetPassword', payload)
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.$notifySuccess(this.$t('messages.verification_sent'))
        })
    },
    confirmUser() {
      this.disabled_btn = true
      this.$vs.loading({
        background: this.backgroundLoading,
        container: '#button-with-loading',
        color: this.colorLoading,
        scale: 0.45
      })
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            code: this.confirmationCode,
            username: this.username,
            details: {
              firstName: this.firstName,
              lastName: this.lastName,
              birthday: this.birthday
            }
          }

          this.$store
            .dispatch('auth/confirmPhone', payload)
            // eslint-disable-next-line no-unused-vars
            .then(response => {
              this.$notifySuccess(this.$t('messages.confirmation_accepted_login'))
              if (this.password) {
                const loginPayload = {
                  checkbox_remember_me: false,
                  userDetails: {
                    phone: this.username,
                    password: this.password
                  }
                }
                this.$store
                  .dispatch('auth/loginJWT', loginPayload)
                  .then(() => {
                    if (sessionStorage.getItem('redirectTo'))
                      window.location = sessionStorage.getItem('redirectTo')
                    this.$router.push({ name: 'dashboard' })

                    if (this.giftCode) {
                      this.$store.dispatch('gift/receiveGift', { code: this.giftCode }).then(() => {
                        sessionStorage.removeItem('referralAffiliate')
                        sessionStorage.removeItem('giftCode')
                      })
                    }
                  })
                  .catch(() => this.$router.push({ name: 'page-login' }))
              } else {
                this.$notifySuccess(this.$t('messages.confirmation_accepted_no_login'))
                this.$router.push({ name: 'page-login' })
              }
              sessionStorage.removeItem('password')
              if (this.referralAffiliate) {
                this.$store
                  .dispatch('affiliate/editAffiliate', {
                    id: this.referralAffiliate.id,
                    data: { ...this.referralAffiliate, level: 'approved' }
                  })
                  .then(() => {
                    sessionStorage.removeItem('referralAffiliate')
                  })
              }
            })
            .finally(() => {
              this.$vs.loading.close('#button-with-loading > .con-vs-loading')
              this.disabled_btn = false
            })
        }
      })
    },
    resetCountDown() {
      this.countDown = 60 * 2
      this.countDownTimer()
      this.resendConfirmationCode()
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    translateNumbers(val) {
      return TranslateNumbers(val)
    }
  }
}
</script>
